interface CircularProgressIndicatorProps {
	height?: number;
	width?: number;
}
const CircularProgressIndicator = ({ height = 16, width = 16 }: CircularProgressIndicatorProps) => {
	return <div style={{ height: height, width: width }} className="circular-progress-indicator" />;
};

export default CircularProgressIndicator;
